import { createContext } from 'react';

export type SideNavContextType = {
  open: boolean;
  onToggle: () => void; 
  buttonProps: any;
  getButtonSubProps: (props?: any) => any;
  openSubProps: boolean;
};

export const SideNavContext = createContext<SideNavContextType>(
  {} as SideNavContextType
);
